import { module_object, PENDO_EVENT, scope_area, action, logPendoEvent, getBaseFields } from './analyticsUtil';

export const trackSupportIconClicked = (specificParams) => {
    const trackingObj = Object.assign(
        {},
        getBaseFields(),
        {
            scope_area: scope_area.CONTROL_CENTER,
            action: action.CLICKED,
            object: module_object.CONTROL_CENTER
        },
        specificParams
    );
    logPendoEvent(PENDO_EVENT.CONTROL_CENTER_SUPPORT_CLICKED, trackingObj);
};

export const trackCreateTicketIconClicked = (specificParams) => {
    const trackingObj = Object.assign(
        {},
        getBaseFields(),
        {
            scope_area: scope_area.CONTROL_CENTER,
            action: action.CLICKED,
            object: module_object.CONTROL_CENTER
        },
        specificParams
    );
    logPendoEvent(PENDO_EVENT.CONTROL_CENTER_CREATE_TICKET_CLICKED, trackingObj);
};

export const trackUserGuideMenuItemClicked = (specificParams) => {
    const trackingObj = Object.assign(
        {},
        getBaseFields(),
        {
            scope_area: scope_area.CONTROL_CENTER,
            action: action.CLICKED,
            object: module_object.CONTROL_CENTER
        },
        specificParams
    );
    logPendoEvent(PENDO_EVENT.CONTROL_CENTER_USER_GUIDE_CLICKED, trackingObj);
};

export const trackVideoTutorialsMenuItemClicked = (specificParams) => {
    const trackingObj = Object.assign(
        {},
        getBaseFields(),
        {
            scope_area: scope_area.CONTROL_CENTER,
            action: action.CLICKED,
            object: module_object.CONTROL_CENTER
        },
        specificParams
    );
    logPendoEvent(PENDO_EVENT.CONTROL_CENTER_VIDEO_TUTORIALS_CLICKED, trackingObj);
};

export const trackFeedbackFormIconClicked = (specificParams) => {
    const trackingObj = Object.assign(
        {},
        getBaseFields(),
        {
            scope_area: scope_area.CONTROL_CENTER,
            action: action.CLICKED,
            object: module_object.CONTROL_CENTER
        },
        specificParams
    );
    logPendoEvent(PENDO_EVENT.CONTROL_CENTER_FEEDBACK_FORM_CLICKED, trackingObj);
};
